export const defaultData = {
  image: {
    url: '@/assets/images/crossmod-form-img.webp',
    alt: 'Crossmod Home',
  },
  imageHeading: 'Connect with us today',
  heading:
    'Schedule a consultation to learn how high-quality, innovative CrossMod homes can streamline your development process, reduce construction time and save you money.',
  description: ``,
  formSections: [
    {
      title: 'Personal Information',
      type: 'text',
      fields: [
        {
          input: 'firstName',
          title: 'First name',
          required: true,
        },
        { input: 'lastName', title: 'Last name', required: true },
        { input: 'email', title: 'Email address', required: true },
        { input: 'phone', title: 'Phone number', required: false },
      ],
    },
    {
      title: 'Development Location',
      type: 'text',
      fields: [
        {
          input: 'city',
          title: 'City',
          required: true,
        },
        { input: 'state', title: 'State', required: true },
        { input: 'zip', title: 'Zip code', required: true },
      ],
    },
  ],
  disclaimer:
    'By submitting this form, I agree that Clayton may contact me by telephone, provide me with marketing communications about Clayton products and servcies, and share my contact information as described in our website terms.',
};
